import { render, staticRenderFns } from "./data-schema-listing.vue?vue&type=template&id=7c12f991&scoped=true&"
import script from "./data-schema-listing.vue?vue&type=script&lang=js&"
export * from "./data-schema-listing.vue?vue&type=script&lang=js&"
import style0 from "./data-schema-listing.vue?vue&type=style&index=0&id=7c12f991&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c12f991",
  null
  
)

export default component.exports